// @ts-nocheck
// Greif UI Kit = line-profile (bold)
import React from "react";

const Profile: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="m12.001 12.32.259.004a7.6 7.6 0 0 1 5.23 2.36 7.8 7.8 0 0 1 2.146 5.384v.007l-.008.127v.007a1.21 1.21 0 0 1-.419.784 1.18 1.18 0 0 1-1.63-.098 1.22 1.22 0 0 1-.325-.825l-.006-.233-.017-.26a5.36 5.36 0 0 0-1.642-3.395 5.2 5.2 0 0 0-3.703-1.436 5.22 5.22 0 0 0-3.64 1.598 5.37 5.37 0 0 0-1.5 3.724v.007l-.008.127v.007a1.22 1.22 0 0 1-.419.784 1.18 1.18 0 0 1-1.63-.098 1.22 1.22 0 0 1-.325-.827v-.003l.003-.26v-.003a7.8 7.8 0 0 1 2.326-5.306 7.58 7.58 0 0 1 5.308-2.176m-.154-7.169c-.511.04-.989.274-1.337.655a2.08 2.08 0 0 0-.541 1.401l.004.156.017.148c.051.346.187.673.397.951.241.318.568.559.941.691s.776.151 1.16.055a2.03 2.03 0 0 0 1-.598 2.088 2.088 0 0 0 .373-2.226 2.05 2.05 0 0 0-.749-.9 2 2 0 0 0-1.111-.337zm4.567 2.056a4.51 4.51 0 0 1-1.293 3.167A4.38 4.38 0 0 1 12 11.686h-.004l-.215-.004h-.002a4.4 4.4 0 0 1-2.978-1.387 4.51 4.51 0 0 1-1.215-3.087v-.002l.005-.218v-.003a4.5 4.5 0 0 1 1.366-3.02A4.38 4.38 0 0 1 12 2.728c1.17 0 2.293.473 3.12 1.312a4.5 4.5 0 0 1 1.294 3.166"
            />
        </svg>
    );
};

export default React.memo(Profile);
